var checkScriptIsLoaded = function (mapProviderName, checkApiIsLoaded, checkApiIsLoading, retry) {
    return new Promise(function (resolve, reject) {
        var delay = retry.delay, maxRetries = retry.maxRetries, retriesLeft = retry.retriesLeft;
        var apiIsLoaded = checkApiIsLoaded();
        var apiIsLoading = checkApiIsLoading();
        if (apiIsLoaded)
            resolve(true);
        if (!apiIsLoading)
            reject(new Error("".concat(mapProviderName, " is not loaded")));
        var count = retriesLeft !== null && retriesLeft !== void 0 ? retriesLeft : maxRetries;
        if (count > 0) {
            setTimeout(function () {
                return checkScriptIsLoaded(mapProviderName, checkApiIsLoaded, checkApiIsLoading, {
                    delay: delay,
                    maxRetries: maxRetries,
                    retriesLeft: count - 1
                })
                    .then(resolve)
                    .catch(reject);
            }, delay);
        }
        else
            reject(new Error("".concat(mapProviderName, " was not detected as loaded after ").concat(delay * maxRetries, "ms")));
    });
};

export { checkScriptIsLoaded };
